export default "__VITE_ASSET__45a22c78__"